import React = require("react");
import {Scrollbar} from "../../../components/Utils/scrollbar/Scrollbar";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {JSONAlarmCategoryStatistics} from "../data/AlarmsMonitorData";
import {AlarmsMonitorDataMapper} from "../utils/AlarmsMonitorDataMapper";
import {VeBoxModal} from "../../../components/modal/VeBoxModal";
import {Button, Checkbox} from "@vebox/etui-core";
import {BUTTON_STYLE} from "../../../components/common/etui_components_styles";

declare var AppTranslations: AppTranslations;

interface Props {
    category: JSONAlarmCategoryStatistics;
    excludedAlarmTypes: number[];
    onApplyFilters: (types: number[]) => void;
    onCancel: () => void;
}

interface State {
    excludedAlarmTypes: number[];
}

export class GlobalMonitorAlarmTypesFilter extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.onReset = this.onReset.bind(this);
        this.onApply = this.onApply.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.toggleAlarmType = this.toggleAlarmType.bind(this);
        this.state = {excludedAlarmTypes: this.props.excludedAlarmTypes};
    }

    public render() {
        if (this.props.category.alarmTypes == null || this.props.category.alarmTypes.length === 0) {
            return null;
        }
        const alarmTypes = (
            <ul className={"alarmTypesOverflow"}>
                {
                    this.props.category.alarmTypes.sort((n1, n2) => n1.name.localeCompare(n2.name)).map(
                        (element, index) => {
                            console.log(element);
                            const color = AlarmsMonitorDataMapper.getSeverityColor(
                                AppTranslations.alarmsMonitor.severities,
                                element.severity,
                            );
                            return (
                                <li
                                    style={
                                        index === this.props.category.alarmTypes.length - 1 ? null : {borderBottom: "1px solid #d8d8d9"}
                                    } key={index}
                                >
                                    <div className={"alarm-type-filter-list__element"}>
                                        <div
                                            className={"alarm-severity-vertical-indicator"}
                                            style={{backgroundColor: color}}
                                        />
                                        <div className={"alarm-type-filter-list__description"}>
                                            <p className={"title"}>{element.name}</p>
                                            {element.description && <p className={"subtitle"}>{element.description}</p>}
                                        </div>
                                        <Checkbox
                                            checked={this.state.excludedAlarmTypes.indexOf(element.id) === -1}
                                            data-id={element.id}
                                            onChange={this.toggleAlarmType}
                                        />
                                    </div>
                                </li>
                            );
                        },
                    )
                }
            </ul>
        );
        return (
            <div className={"cover-content-container"}>
                <VeBoxModal className={"alarm-filter-type-modal"}>
                    <VeBoxModal.Header title={this.props.category.categoryName}/>
                    <VeBoxModal.Body>
                        <VeBoxModal.Section className={"alarm-type-filter__content--scroll"}>
                            {alarmTypes}
                        </VeBoxModal.Section>
                    </VeBoxModal.Body>
                    <VeBoxModal.StandardActions
                        /*submitText={AppTranslations.alarmsMonitor.texts.okText}
                        cancelText={AppTranslations.alarmsMonitor.texts.cancelText}*/
                        onSubmit={this.onApply}
                        onCancel={this.onCancel}
                    />
                </VeBoxModal>
            </div>
        );
    }

    private toggleAlarmType(e: React.ChangeEvent<HTMLInputElement>) {
        console.log(e);
        // tslint:disable-next-line:radix
        const alarmType = parseInt(e.target["data-id"]);
        console.log(e.target["data-id"]);
        const alarmTypes = this.state.excludedAlarmTypes;
        if (alarmTypes.indexOf(alarmType) >= 0) {
            alarmTypes[alarmTypes.indexOf(alarmType)] = null;
        } else {
            alarmTypes.push(alarmType);
        }
        this.setState({
                excludedAlarmTypes: alarmTypes.filter(
                    (element) => {
                        return element != null;
                    },
                ),
            },
        );
    }

    private onApply() {
        this.props.onApplyFilters(this.state.excludedAlarmTypes);
    }

    private onReset() {
        this.setState({excludedAlarmTypes: []});
    }

    private onCancel() {
        this.props.onCancel();
    }
}
